import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom'
import App from './App';
import './index.css'
import { registerServiceWorker } from './helper/push-helper';

window.API_URL = process.env.REACT_APP_API_URL || window.API_URL;
if (!window.API_URL) {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    window.API_URL = 'http://localhost:8000';
  } else {
    window.API_URL = 'https://api.betacommunes.com';
  }
}

// Register service worker early so it's ready when the user logs in.
// Push subscription is triggered after login in Login.jsx (needs auth token).
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
        <App />
        </BrowserRouter>
  </React.StrictMode>
);